import { render, staticRenderFns } from "./Normal.vue?vue&type=template&id=72f2c413&scoped=true&"
import script from "./Normal.vue?vue&type=script&lang=js&"
export * from "./Normal.vue?vue&type=script&lang=js&"
import style0 from "./Normal.vue?vue&type=style&index=0&id=72f2c413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2c413",
  null
  
)

export default component.exports